// extracted by mini-css-extract-plugin
export default {"topic":"ForumTopic_topic__77Lz7","text-main":"ForumTopic_text-main__dQbiD","text-additional":"ForumTopic_text-additional__kxtrw","button":"ForumTopic_button__NEGtS"};